import {ObjectSchema, ParserConfig, saveObjectConfig} from "../../api/config";
import {Button, Tabs} from "antd";
import {TextConfigEditor} from "./components/textConfigEditor";
import {ParseResults} from "./components/parseResultTable";
import React, {useEffect, useState} from "react";
import Sider from "antd/es/layout/Sider";
import {refreshChildUrls} from "../../api/urls";
import {ParsedItem, parseHTML} from "../../api/extract";

const {TabPane} = Tabs;

interface SiderParams {
    pageTypeID: number
    currentURL: string | null
    proxy: string | null
    schema: ObjectSchema | null
    config: ParserConfig | null,

    onConfigChanged: (config: ParserConfig) => void
    onSave: () => void
}

interface ParseResult {
    total: number
    errorCount: number
    items: ParsedItem[] | null
}

export function RightColumn({pageTypeID, currentURL, schema, config, proxy, onConfigChanged, onSave}: SiderParams) {
    const [parseResult, setParseResult] = useState<ParseResult>({errorCount: 0, total: 0, items: []});
    const [saveInProgress, setSaveInProgress] = useState(false);
    const [draftConfig, setDraftConfig] = useState<ParserConfig | null>(config);

    useEffect(() => {
        const do_ = async () => {
            if (!currentURL || !config || !proxy) {
                return
            }
            const parseResult = await parseHTML(currentURL, config, proxy);
            if (parseResult.config_modified) {
                onConfigChanged(parseResult.config);
            }

            let parsedErrors = 0;
            for (const item of parseResult.items) {
                if (!item.is_valid) {
                    parsedErrors += 1
                }
            }

            setParseResult({
                total: parseResult.items.length,
                errorCount: parsedErrors,
                items: parseResult.items
            })
        }
        do_();
    }, [config, currentURL]);

    const saveConfig = async () => {
        try {
            setSaveInProgress(true);
            await saveObjectConfig(schema!.slug, pageTypeID, config!);

            if (schema!.slug == "crawl") {
                await refreshChildUrls(pageTypeID, currentURL!, proxy!);
            }
            onConfigChanged(config!)
            onSave()
        } finally {
            setSaveInProgress(false);
        }
    }

    return <Sider collapsible={false} reverseArrow={true} width={500}
                  className="site-layout-background sider">
        <Button onClick={() => saveConfig()} loading={saveInProgress}>Сохранить</Button>

        <Tabs defaultActiveKey="1" className="xpather-tabs">
            <TabPane tab="JSON" key="1" style={{
                overflow: "auto",
                height: "75vh"
            }}>
                <TextConfigEditor
                    config={config}
                    onApplyDraftConfig={() => onConfigChanged(draftConfig!)}
                    onDraftConfigChange={(newDraft) => setDraftConfig(newDraft)}
                />
            </TabPane>

            <TabPane tab={`Результаты: ${parseResult.total} (${parseResult.errorCount} ошибок)`} key="2" style={{
                overflow: "auto",
                height: "75vh"
            }}>
                <ParseResults items={parseResult.items}/>
            </TabPane>
        </Tabs>
    </Sider>
}
